import React, { Fragment, FC } from 'react';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ContainedItems } from './contained-items';
import { useTranslate } from '@refinedev/core';

import styles from './packages.module.scss';
import { ICategory } from '../../../../interfaces';
import { buildKey } from '../../../../utils/accessory';
import { Button, Col, Divider, Form, Row, Space } from 'antd';
import { useSelect } from '@refinedev/antd';
import { FormItem, Input, Checkbox, Select, Textarea } from 'components/ui';
import cn from 'classnames';

const FIELD_KEY = 'packages';

export const Packages: FC = () => {
    const t = useTranslate();

    const { selectProps: packageTypes } = useSelect<ICategory>({
        resource: 'dictionary/package_types',
        defaultValue: [],
        optionLabel: 'name',

        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        meta: {},

        pagination: {
            mode: 'server',
        },
    });

    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} md={24} style={{ marginTop: 9, marginBottom: 9 }}>
                <Form.List name={FIELD_KEY}>
                    {(fields, { add, remove }, { errors }) => {
                        return (
                            <div>
                                {fields?.length > 0 && (
                                    <Divider>
                                        {t('applications.fields.packaging')}
                                    </Divider>
                                )}
                                {fields.map((field, index) => (
                                    <Fragment
                                        key={buildKey(FIELD_KEY, ++field.key)}
                                    >
                                        <Space
                                            align="start"
                                            className={cn(
                                                styles.packagingWrap,
                                                styles.holder
                                            )}
                                        >
                                            <Row
                                                gutter={[16, 16]}
                                                style={{
                                                    width: '100%',
                                                }}
                                            >
                                                <Col
                                                    span={24}
                                                    style={{
                                                        display: 'none',
                                                    }}
                                                >
                                                    <FormItem
                                                        {...field}
                                                        name={[
                                                            field.name,
                                                            'id',
                                                        ]}
                                                        initialValue={index + 1}
                                                    >
                                                        <Input
                                                            disabled
                                                            label={t(
                                                                'applications.fields.id'
                                                            )}
                                                        />
                                                    </FormItem>
                                                </Col>

                                                <Col span={24}>
                                                    <FormItem
                                                        {...field}
                                                        name={[
                                                            field.name,
                                                            'typeId',
                                                        ]}
                                                    >
                                                        <Select
                                                            {...packageTypes}
                                                            label={t(
                                                                'applications.fields.package_type_id'
                                                            )}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </FormItem>
                                                </Col>

                                                <Col span={24}>
                                                    <FormItem
                                                        {...field}
                                                        name={[
                                                            field.name,
                                                            'description',
                                                        ]}
                                                    >
                                                        <Textarea
                                                            label={t(
                                                                'applications.fields.description'
                                                            )}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </FormItem>
                                                </Col>

                                                <Col span={24}>
                                                    <FormItem
                                                        {...field}
                                                        name={[
                                                            field.name,
                                                            'isFinal',
                                                        ]}
                                                        valuePropName="checked"
                                                        initialValue={false}
                                                    >
                                                        <Checkbox
                                                            title={t(
                                                                'applications.fields.package_is_final'
                                                            )}
                                                        />
                                                    </FormItem>
                                                </Col>

                                                <Col span={24}>
                                                    <FormItem
                                                        {...field}
                                                        name={[
                                                            field.name,
                                                            'certificateText',
                                                        ]}
                                                    >
                                                        <Input
                                                            label={t(
                                                                'applications.fields.package_certificate_text'
                                                            )}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </FormItem>
                                                </Col>

                                                <Col span={24}>
                                                    <Row
                                                        justify="end"
                                                        gutter={[16, 16]}
                                                    >
                                                        <Col>
                                                            <Button
                                                                type="text"
                                                                danger
                                                                icon={
                                                                    <MinusCircleOutlined />
                                                                }
                                                                onClick={() =>
                                                                    remove(
                                                                        field.name
                                                                    )
                                                                }
                                                                aria-label={t(
                                                                    'buttons.delete'
                                                                )}
                                                            >
                                                                {t(
                                                                    'buttons.delete'
                                                                )}
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Space>
                                        <Space
                                            align="start"
                                            className={styles.holder}
                                        >
                                            <Form.Item
                                                style={{
                                                    width: '100%',
                                                }}
                                            >
                                                <ContainedItems
                                                    fieldKey={field.name}
                                                />
                                            </Form.Item>
                                        </Space>
                                    </Fragment>
                                ))}
                                {fields?.length > 0 && (
                                    <Divider style={{ margin: '16px 0' }} />
                                )}
                                <Button
                                    type="dashed"
                                    onClick={() => {
                                        add({}, fields?.length);
                                    }}
                                    block
                                    style={{ marginBottom: 20 }}
                                >
                                    <PlusOutlined />{' '}
                                    {t('applications.fields.add_packaging')}
                                </Button>
                                <Form.ErrorList errors={errors} />
                            </div>
                        );
                    }}
                </Form.List>
            </Col>
        </Row>
    );
};
